module.exports = __webpack_public_path__ + "img/order_submit_succ.c84efc85.png";